import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

type ContainerCol = { id: number; name: string };

@Component({
  selector: 'app-place-inventory-by-place-preview',
  templateUrl: './place-inventory-by-place-preview.component.html',
  styleUrls: ['./place-inventory-by-place-preview.component.scss']
})
export class PlaceInventoryByPlacePreviewComponent implements OnChanges {

  @Input() products: any[] | null = null;
  @Input() loading = false;

  containerCols: ContainerCol[] = [];

  qtyMatrix = new Map<number, Map<number, number>>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['products']) {
      this.buildTableModel();
    }
  }

  private buildTableModel(): void {
    this.containerCols = [];
    this.qtyMatrix.clear();

    const products = this.products ?? [];
    if (!products.length) return;

    const containerMap = new Map<number, string>();
    for (const p of products) {
      for (const c of (p.containers ?? [])) {
        if (c?.containerId != null && !containerMap.has(c.containerId)) {
          containerMap.set(c.containerId, c.containerName ?? `#${c.containerId}`);
        }
      }
    }

    this.containerCols = Array.from(containerMap.entries())
      .map(([id, name]) => ({ id, name }))
      .sort((a, b) => a.name.localeCompare(b.name));

    for (const p of products) {
      const row = new Map<number, number>();
      for (const c of (p.containers ?? [])) {
        if (c?.containerId != null) row.set(c.containerId, this.toNum(c.qty));
      }
      this.qtyMatrix.set(p.productId, row);
    }
  }

  qtyOf(productId: number, containerId: number): number {
    return this.qtyMatrix.get(productId)?.get(containerId) ?? 0;
  }

  totalOf(p: any): number {
    return this.containerCols.reduce((sum, col) => sum + this.qtyOf(p.productId, col.id), 0);
  }

  trackByContainer = (_: number, c: ContainerCol) => c.id;
  trackByProduct = (_: number, p: any) => p.productId;

  private toNum(v: any): number {
    if (v == null) return 0;
    const n = typeof v === 'number' ? v : Number(v);
    return Number.isFinite(n) ? n : 0;
  }
}
